import React, { useState } from "react";
import { LoginWrapper } from "../../Auth/LoginWrapper";
import { IntroText, ApiImage, PatientAuthByDob } from "../../../components";
import { useTranslation } from "react-i18next";
import { POST_ADD_VAX_YES_VERIFY_CERTIFICATE } from "../../../queries";
import { useMutation } from "@apollo/react-hooks";
import {
  Box,
  Paper,
  CircularProgress,
  Button,
  Link,
  Typography
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import { Alert, AlertTitle } from "@material-ui/lab";

const VaxYesVerify = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [images, setImages] = useState({});

  const [postVerifyVaxYesCertificate, { loading }] = useMutation(
    POST_ADD_VAX_YES_VERIFY_CERTIFICATE,
    {
      onCompleted: ({ certificate }) => {
        if (
          certificate &&
          certificate.status &&
          certificate.status === "success" &&
          certificate.image1
        ) {
          setImages(certificate);
        } else {
          enqueueSnackbar(
            "There was an error retrieving your vaccine card image",
            {
              variant: "error"
            }
          );
        }
      },
      onError: () => {
        enqueueSnackbar("There was an error retrieving your details", {
          variant: "error"
        });
      }
    }
  );

  const onSubmit = ({ dob = "" }) => {
    postVerifyVaxYesCertificate({
      variables: {
        body: {
          dob,
          query: location.search.split("query=")[1]
        }
      }
    });
  };

  return (
    <LoginWrapper>
      <Box mx={2}>
        <Paper>
          <Box p={2} textAlign={loading ? "center" : ""}>
            {loading ? (
              <CircularProgress />
            ) : images.image1 ? (
              <Box my={1} key={`cert-images-1`}>
                {images.level && (
                  <Box my={2}>
                    <Alert severity="success">
                      <AlertTitle>
                        Verification level - {images.level}
                      </AlertTitle>
                      Go to{" "}
                      <Link
                        href="https://www.gogetdoc.com/vaxyes"
                        target="_blank"
                      >
                        gogetdoc.com/vaxyes
                      </Link>{" "}
                      for more details
                    </Alert>
                  </Box>
                )}
                <ApiImage
                  key={`cert-image-1`}
                  path={images.image1}
                  apiRoot=""
                />
                {images.image2 && (
                  <Box mt={2}>
                    <Typography gutterBottom>Booster shot:</Typography>
                    <ApiImage
                      key="cert-image-2"
                      path={images.image2}
                      apiRoot=""
                    />
                  </Box>
                )}
              </Box>
            ) : (
              <>
                <IntroText>{t("vax_yes.vax_yes_verify.intro_text")}</IntroText>
                <PatientAuthByDob handleOnSubmit={onSubmit}>
                  <Button
                    disabled={loading}
                    type="submit"
                    fullWidth
                    color="primary"
                    variant="contained"
                  >
                    {t("vax_yes.vax_yes_verify.button_text")}
                  </Button>
                </PatientAuthByDob>
              </>
            )}
          </Box>
        </Paper>
      </Box>
    </LoginWrapper>
  );
};

export { VaxYesVerify };
